export default __webpack_public_path__ + "static/media/iconUser.a7fc9727.svg";